import './AnalyticsCriteriaCard.css';
import { useState } from "react";
import { useToastDispatchContext } from '/src/layouts/toast/context/toastContext';
const AnalyticsCriteriaCard = ({ title, value, subtitle, fontSize, copiedValue, onClick, onGoToConversations, goToConversationsHref }) => {
  const [copied, setCopied] = useState(false);
  const toast = useToastDispatchContext();

  const handleCopy = async () => {
    if (!copiedValue) return;

    try {
      await navigator.clipboard.writeText(copiedValue);
      setCopied(true);
      toast.success('Copied', `The value of the box has been copied`, 5000);

      setTimeout(() => setCopied(false), 1500);
    } catch (err) {
      console.error("Copy failed", err);
    }
  };

  const isClickable = !!onClick || !!copiedValue;

  return (
    <div
      className={`analytics-criteria-card ${copied ? 'copied' : ''} ${onClick ? 'analytics-criteria-card-navigable' : ''}`}
      onClick={onClick || handleCopy}
      style={{ cursor: isClickable ? "pointer" : "default" }}
      title={copiedValue || ""}
    >
      {copiedValue && <i className="fas fa-copy analytics-copy-icon"></i>}
      <div className="analytics-criteria-title">{title}</div>
      <div className="analytics-criteria-value" style={{ fontSize: fontSize + "px" }}>{value}</div>
      {subtitle && <div className="analytics-criteria-subtitle">{subtitle}</div>}
      {onGoToConversations && (
        <a
          className="analytics-criteria-goto-conversations"
          href={goToConversationsHref || undefined}
          target="_blank"
          rel="noopener noreferrer"
          onClick={(e) => e.stopPropagation()}
        >
          Redirect to conversations
        </a>
      )}
    </div>
  );
};

export default AnalyticsCriteriaCard;